'use client';

import { ReactNode } from 'react';
import { useTranslations } from 'next-intl';
export type ToastV4Variant = 'info' | 'success' | 'error' | 'warning';
const TITLE_KEYS: Record<ToastV4Variant, string> = {
  info: 'toast-v4.info-title',
  success: 'toast-v4.success-title',
  error: 'toast-v4.error-title',
  warning: 'toast-v4.warning-title'
};

/**
 * Title + message layout for the v4 toast design (Figma node 4050:539).
 * Rendered inside the ToastContainer, so next-intl context is available.
 */
const ToastV4Body = ({
  variant,
  title,
  children
}: {
  variant: ToastV4Variant;
  title?: ReactNode;
  children: ReactNode;
}) => {
  const t = useTranslations();
  return <div className="toast-v4__content" data-sentry-component="ToastV4Body" data-sentry-source-file="ToastV4Body.tsx">
            <div className="toast-v4__title">{title ?? t(TITLE_KEYS[variant])}</div>
            <div className="toast-v4__message">{children}</div>
        </div>;
};
export default ToastV4Body;